<dds-header
  [name]="headerOptions.name ?? ''"
  [isResponsive]="headerOptions.isResponsive ?? true"
  [isInverse]="headerOptions.isInverse ?? false"
  [responsivePriority]="responsivePriority"
>
  <dds-logo logo></dds-logo>
  <ng-container navigation>
    <app-search-box [permissionObj]="permissionObj"></app-search-box>
  </ng-container>

  <ng-container icons>
    <dds-dropdown
      class="custom-dropdown"
      [theme]="headerButtonOptions.theme ?? ''"
      [icon]="dropdownOptions.icon ?? ''"
      [kind]="dropdownOptions.kind ?? ''"
      [size]="dropdownOptions.size ?? ''"
      [label]="dropdownOptions.label ?? ''"
      [width]="dropdownOptions.width ?? ''"
      [isInverse]="dropdownOptions.isInverse ?? false"
      [isColorBg]="dropdownOptions.isColorBg ?? false"
      [disabled]="dropdownOptions.disabled ?? false"
      [isResponsive]="dropdownOptions.isResponsive ?? false"
      [stickerWidth]="dropdownOptions.stickerWidth ?? ''"
      [stickerIsOutsideClick]="dropdownOptions.stickerIsOutsideClick ?? false"
      [stickerIndent]="dropdownOptions.stickerIndent ?? 0"
      [stickerCustomClass]="dropdownOptions.stickerCustomClass ?? ''"
      [stickerIsDynamic]="dropdownOptions.stickerIsDynamic ?? false"
      (itemSelected)="itemSelected($event)"
    >
      <!-- ToDO:- Need to fix aligment of the button and show dropdown sticker on bottom right -->

      <dds-dropdown-item
        *ngFor="let item of dropdownItems"
        [value]="item.value"
        >{{ item.heading }}</dds-dropdown-item
      >
    </dds-dropdown>

    <dds-dropdown
      class="custom-dropdown"
      [theme]="headerButtonOptions.theme ?? ''"
      [icon]="'dds-icon_setting__l__stroke'"
      [kind]="dropdownOptions.kind ?? ''"
      [size]="dropdownOptions.size ?? ''"
      [label]="dropdownOptions.label ?? ''"
      [width]="dropdownOptions.width ?? ''"
      [isInverse]="dropdownOptions.isInverse ?? false"
      [isColorBg]="dropdownOptions.isColorBg ?? false"
      [disabled]="dropdownOptions.disabled || !(additionalOptions.length > 0)"
      [isResponsive]="dropdownOptions.isResponsive ?? false"
      [stickerWidth]="dropdownOptions.stickerWidth ?? ''"
      [stickerIsOutsideClick]="dropdownOptions.stickerIsOutsideClick ?? false"
      [stickerIndent]="dropdownOptions.stickerIndent ?? 0"
      [stickerCustomClass]="dropdownOptions.stickerCustomClass ?? ''"
      [stickerIsDynamic]="dropdownOptions.stickerIsDynamic ?? false"
      (itemSelected)="additionaloptionSelected($event)"
    >
      <!-- ToDO:- Need to fix aligment of the button and show dropdown sticker on bottom right -->

      <dds-dropdown-item
        *ngFor="let item of additionalOptions; trackBy: trackByValue"
        [value]="item.value"
        [disabled]="item?.disabled ?? false"
        >{{ item.heading }}</dds-dropdown-item
      >
    </dds-dropdown>
    <dds-button
      [theme]="headerButtonOptions.theme ?? ''"
      hostRole="menuitem"
      class="customHeaderButton"
      (clicked)="downloadGuidanceDocument()"
    >
      <img src="../../assets/images/guidance icon.svg" />
    </dds-button>
  </ng-container>

  <ng-container profile>
    <dds-profile
      [username]="profileOptions.username ?? ''"
      [photoUrl]="profileOptions.photoUrl ?? ''"
      [userInfo]="globalUserRoles ?? ''"
      [stickerWidth]="profileOptions.stickerWidth ?? ''"
      [stickerIsDynamic]="profileOptions.stickerIsDynamic ?? false"
      role="menuitem"
    >
      <!-- display global and local roles-->
      <dds-profile-item
        class="user-roles"
        *ngIf="localUserRoles.length && !isDashboard"
      >
        <div class="image-align">&nbsp;</div>
        <div class="roles">
          <span
            class="roles-seperator"
            *ngIf="
              (globalUserRoles.length && localUserRoles.length) ||
              localUserRoles.length
            "
          ></span>
          <ng-container *ngIf="localUserRoles.length"
            ><div *ngFor="let roles of localUserRoles">
              {{ roles.roleName }}
            </div></ng-container
          >
        </div>
      </dds-profile-item>
      <span class="seperator"></span>
      <dds-profile-item #logout>Log out </dds-profile-item>
    </dds-profile>
  </ng-container>
</dds-header>
